<bdeo-drawer #drawer closable="true" overlay [headerTitle]="'review_form.review_title' | i18nextEager">
  <div class="review-drawer">
    <p class="review-drawer__description">
      @if (smartphoto?.attributes?.useCase === 'Claim') {
        {{ 'review_form.review_description_claim' | i18nextEager }}
      } @else {
        {{ 'review_form.review_description_underwriting' | i18nextEager }}
      }
    </p>
    <br />
    <form [formGroup]="reviewForm" class="review-drawer__review-form">
      @for (field of fields; track $index) {
        @if (field.type === 'list') {
          <bdeo-select
            formControlName="{{ field.properties[0] }}"
            type="form"
            size="medium"
            [required]="field.required || false"
            placeholder="{{ field.placeholder }}"
            label="{{ field.label }}"
            [addNew]="true"
            [options]="field.options"
            ngDefaultControl
          />
        } @else if (field.type === 'radio') {
          <radio-list-input [field]="field" formControlName="{{ field.properties[0] }}" ngDefaultControl></radio-list-input>
        } @else if (field.type === 'textarea') {
          <bdeo-textarea
            formControlName="{{ field.properties[0] }}"
            label="{{ field.label | i18nextEager }}"
            placeholder="{{ field.placeholder ?? '' | i18nextEager }}"
            height="max"
            [required]="field.required || false"
            ngDefaultControl
          ></bdeo-textarea>
        } @else {
          <bdeo-input
            formControlName="{{ field.properties[0] }}"
            type="form"
            size="medium"
            variant="{{ field.type }}"
            placeholder="{{ field.placeholder ?? '' | i18nextEager }}"
            label="{{ field.label | i18nextEager }}"
            value=""
            ngDefaultControl
            [required]="field.required || false"
          />
        }
      }
    </form>
    @if (hasAdditionals) {
      <section class="review-drawer__additionals-form">
        <p class="review-drawer__description">
          {{ 'review_form.review_description_additionalsEmail' | i18nextEager }}
        </p>
        <form [formGroup]="additionalsForm">
          <email-chip-input formControlName="emails" ngDefaultControl></email-chip-input>
          <div class="review-drawer__additionals-form-notes">
            <bdeo-textarea
              type="form"
              size="large"
              placeholder="{{ 'review_form.notes_placeholder' | i18nextEager }}"
              height="max"
              ngDefaultControl
              formControlName="notes"
            >
            </bdeo-textarea>
          </div>
        </form>
      </section>
    }
  </div>
  <app-footer selectorForPadding=".review-drawer">
    <bdeo-button
      data-test-id="save-review"
      type="primary"
      [icon]="inProgress ? 'loading-circle' : 'action-send-outline'"
      [text]="'actions.save_review' | i18nextEager"
      [disabled]="inProgress || !reviewForm.valid || !additionalsForm.valid"
      (click)="review()"
    ></bdeo-button>
    <bdeo-button type="secondary" skin="ghost" [text]="'actions.transaction_reject' | i18nextEager" (click)="close()"></bdeo-button>
  </app-footer>
</bdeo-drawer>
